import Axios from "../../setting/axios";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { toast } from "react-toastify";
import axios from "../../setting/axios";

// hooks/UseProjectsDetails.js
export const GetProjectsForUrl = async (slug) => {
  try {
    const response = await Axios.post(
      "/projects-details/get-projects-for-url",
      { slug }
    );
    console.log(response.data, "response.data` in GetProjectsForUrl");
    return response.data; // successful path
  } catch (err) {
    console.log("GetProjectsForUrl error.response?.data:", err.response?.data);
    if (err.response && err.response.data) {
      throw err.response.data; // Throw the backend data (which should have suggestion etc.)
    }
    throw err; // fallback
  }
};

const AddProjectsDetails = async (data) => {
  try {
    const response = await Axios.post(
      "/projects-details/add-projects-details",
      data,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    console.log("[AddProjectsDetails] API response:", response.data);
    return response.data;
  } catch (err) {
    console.error(
      "[AddProjectsDetails] Error:",
      err.response?.data?.message || err.message
    );
    console.error("[AddProjectsDetails] Full error:", err);
    throw new Error(
      err.response?.data?.message || "Failed to add project details"
    );
  }
};

const EditProjectsDetails = async ({ id, data }) => {
  try {
    const response = await Axios.put(
      `/projects-details/edit-projects-details/${id}`,
      data,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    console.log("[EditProjectsDetails] API response:", response.data);
    return response.data;
  } catch (err) {
    console.error(
      "[EditProjectsDetails] Error:",
      err.response?.data?.message || err.message
    );
    console.error("[EditProjectsDetails] Full error:", err);
    throw new Error(
      err.response?.data?.message || "Failed to edit project details"
    );
  }
};

const GetProjectDetails = async (projectId) => {
  try {
    const response = await Axios.post(
      "/projects-details/get-project-details",
      { prj_id: projectId },
      { headers: { "Content-Type": "application/json" } }
    );
    console.log("[GetProjectDetails] API response:", response.data);
    return response.data;
  } catch (err) {
    console.error(
      "[GetProjectDetails] Error:",
      err.response?.data?.error || err.message
    );
    console.error("[GetProjectDetails] Full error:", err);
    throw new Error(
      err.response?.data?.error || "Failed to fetch project details"
    );
  }
};

const GetProjectFiles = async ({ project_id, file_type = null }) => {
  try {
    const response = await Axios.post(
      "/projects-details/get-project-files",
      { project_id, file_type },
      { headers: { "Content-Type": "application/json" } }
    );
    console.log("[GetProjectFiles] API response:", response.data);
    return response.data;
  } catch (err) {
    console.error(
      "[GetProjectFiles] Error:",
      err.response?.data?.error || err.message
    );
    console.error("[GetProjectFiles] Full error:", err);
    throw new Error(
      err.response?.data?.error || "Failed to fetch project files"
    );
  }
};

// Updated DELETE function to use POST with request body
const DeleteSelectedProject = async (ids) => {
  try {
    const response = await Axios.post(`/projects-details/delete-selected-project`, {
      project_id: ids,
    });
    return response;
  } catch (err) {
    return err;
  }
};

export const useDeleteSelectedProject = () => {
  return useMutation(DeleteSelectedProject);
};

// Get all projects
const GetAllProjects = async () => {
  try {
    const response = await Axios.post(
      "/projects-details/get-all-projects",
      {},
      { headers: { "Content-Type": "application/json" } }
    );
    return response.data;
  } catch (err) {
    console.error("[GetAllProjects] Full error:", err);
    throw new Error(err.response?.data?.error || "Failed to fetch projects");
  }
};

// Hook for adding projects
export const useAddProjectsDetails = (dispatch) => {
  const queryClient = useQueryClient();

  return useMutation(AddProjectsDetails, {
    onSuccess: (data) => {
      toast.success("Project details added successfully!");
      queryClient.invalidateQueries(["allprojects"]);
      if (dispatch) {
        dispatch({ event: "allprojects" });
      }
    },
    onError: (error) => {
      console.error("[useAddProjectsDetails] Mutation error:", error);
      toast.error(error.message || "Failed to add project details");
    },
  });
};

// Hook for editing projects
export const useEditProjectsDetails = (options = {}) => {
  return useMutation(EditProjectsDetails, {
    ...options,
    onSuccess: (data) => {
      // toast.success("Project details updated successfully!");
      if (options.onSuccess) {
        options.onSuccess(data);
      }
    },
    onError: (error) => {
      console.error("[useEditProjectsDetails] Mutation error:", error);
      toast.error(error.message || "Failed to edit project details");
      if (options.onError) {
        console.log("[useEditProjectsDetails] Calling custom onError callback");
        options.onError(error);
      }
    },
  });
};

// Hook for getting project details
export const useGetProjectDetails = (projectId) => {
  console.log(
    "[useGetProjectDetails] Hook initialized with project ID:",
    projectId
  );
  return useQuery(
    ["project-details", projectId],
    () => GetProjectDetails(projectId),
    {
      enabled: !!projectId,
      onSuccess: (data) => {
        console.log("[useGetProjectDetails] Query success:", data);
      },
      onError: (error) => {
        console.error("[useGetProjectDetails] Query error:", error);
        toast.error(error.message || "Failed to fetch project details");
      },
    }
  );
};

// Hook for getting project files
export const useGetProjectFiles = (project_id, file_type = null) => {
  console.log(
    "[useGetProjectFiles] Hook initialized with project_id:",
    project_id,
    "file_type:",
    file_type
  );
  return useQuery(
    ["project-files", project_id, file_type],
    () => GetProjectFiles({ project_id, file_type }),
    {
      enabled: !!project_id,
      onSuccess: (data) => {
        console.log("[useGetProjectFiles] Query success:", data);
      },
      onError: (error) => {
        console.error("[useGetProjectFiles] Query error:", error);
        toast.error(error.message || "Failed to fetch project files");
      },
    }
  );
};

// Hook for getting all projects
export const useGetAllProjects = (options = {}) => {
  console.log("[useGetAllProjects] Hook initialized");
  return useQuery(["allprojects", "all"], GetAllProjects, {
    onSuccess: (data) => {
      console.log(
        "[useGetAllProjects] Query success - fetched",
        data.length,
        "allprojects"
      );
    },
    onError: (error) => {
      console.error("[useGetAllProjects] Query error:", error);
      toast.error(error.message || "Failed to fetch projects");
    },
    ...options,
  });
};

// Hook for deleting projects - Updated to use POST method
// export const useDeleteSelectedProject = () => {
//   const queryClient = useQueryClient();

//   return useMutation({
//     mutationFn: DeleteSelectedProject,
//     onSuccess: (data, projectId) => {
//       // CHANGE: Removed console.log for success
//       toast.success(`Project "${data.projectName}" deleted successfully!`);
//       queryClient.invalidateQueries(["allprojects"]);
//     },
//     onError: (error, projectId) => {
//       // CHANGE: Kept error logging for debugging, simplified
//       console.error(
//         `[useDeleteSelectedProject] Error deleting project ID: ${projectId}:`,
//         error
//       );
//       toast.error(error.message || "Failed to delete project");
//     },
//     onSettled: () => {
//       // CHANGE: Removed console.log for settled
//     },
//   });
// };
